// extracted by mini-css-extract-plugin
export default {"cardWrapper":"Card_cardWrapper__So3LT","title":"Card_title__fH4KS"};